import req from '../../api/request'

interface SendCheerOptions {
  team?: string
  emoji?: string
}

export const sendCheer = async (
  gameId: string,
  { team = 'home', emoji = ':clap:' }: SendCheerOptions = {}
) => {
  return await req(`/games/${gameId}/cheer`, {
    method: 'POST',
    body: JSON.stringify({ team, emoji }),
  })
}
